// 资源包详情页路由前缀推导（2026-06-13 pending §11 归因作用域）。
//   /#/s/:packId   外部分享落地（设归因 cookie）
//   /#/pack/:packId 站内导航（不设归因 cookie）
// 子页 /files 的返回 / 订阅跳转需保持来源前缀，故按当前 location 推导。
import { useLocation } from 'react-router-dom'

/** 按路径前缀推 base：'/s'(归因落地) 或 '/pack'(站内不归因)。兜底 '/pack'（不归因更安全）。 */
export function packBasePath(pathname: string): '/s' | '/pack' {
  return pathname.startsWith('/s/') ? '/s' : '/pack'
}

/** 当前资源包详情页的 base 前缀（子页 /files 跳转 / 返回用）。 */
export function usePackBasePath(): '/s' | '/pack' {
  return packBasePath(useLocation().pathname)
}
